import Skeleton from "react-loading-skeleton";
import { arrayMap } from "../../../../utils/array.utils";
import { stockListFormatter } from "../../../../utils/stockList.utils";
import VehicleShowroomWorksAddButton from "./VehicleShowroomWorksAddButton";
import VehicleShowroomWorksView, { VehicleInventoryViewSkeleton } from "./VehicleShowroomWorksView";
import { getRandomNumber } from "../../../../utils/number.utils";

export default function VehicleShowroomWorks({ data, loading, children }) {
  const formattedData = stockListFormatter(data);
  const showroom_works = formattedData?.showroom_works ?? [];

  return (
    <div>
      {children}
      <div className="row mt-0 g-3">
        {arrayMap(showroom_works, (item) => (
          <div className="col-12" key={item?.id}>
            <VehicleShowroomWorksView data={item} />
          </div>
        )) || <VehicleShowroomWorksAddButton data={data} />}
      </div>
    </div>
  );
}

// skeleton
export function VehicleInventorySkeleton() {
  return (
    <div>
      <Skeleton width={`${getRandomNumber(30, 60)}%`} />
      <div className="row mt-0 g-3">
        {arrayMap(Array(1).fill(0), (_, i) => (
          <div className="col-12" key={i}>
            <VehicleInventoryViewSkeleton />
          </div>
        ))}
      </div>
    </div>
  );
}
